import {useTranslation} from 'react-i18next'
import {Flex, Text} from '@chakra-ui/react'

import {toLocalDate, toLocalTime} from '~/utils/formatter'

import PaymentPropType from '../../propTypes'
import PaymentStatus from '../PaymentStatus'
import RewardDetails from './RewardDetails'

const SummarySection = ({payment}) => {
  const {t} = useTranslation('pointsOnPayments')

  return (
    <Flex direction="column" gap="xs">
      <Flex justify="space-between" gap="xs">
        <Text textStyle="body-intro-medium">
          {t('pointsOnPayments:pointsOnPayment.drawer.summarySectionTitle')}
        </Text>
        <PaymentStatus status={payment.status} />
      </Flex>
      <Flex justify="end">
        <Text textStyle="body-small-medium">
          {`${toLocalDate(payment.createdAt, {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
          })}, ${toLocalTime(payment.createdAt)}`}
        </Text>
      </Flex>
      <Flex justify="end">
        <RewardDetails
          status={payment.status}
          marmaladePointsEarnt={payment.marmaladePointsEarnt}
        />
      </Flex>
    </Flex>
  )
}

SummarySection.propTypes = {
  payment: PaymentPropType.isRequired,
}

export default SummarySection
